// Inicializa animaciones WOW.js
export const animationCreate = () => {
  if (typeof window !== 'undefined' && window.WOW) {
    const wow = new window.WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();
  }
};
